import "../../styles/discover.css";

const Discover = () => {
  return (
    <div id="discover-container">
      <div className="discover-products">
        <img src="./images/products.png" alt="products" />
      </div>
      <div className="discover-text">
        <img src="./images/discover-text.png" alt="discover-text" />
        <a
          href="https://ad.doubleclick.net/ddm/trackclk/N192603.3333133BUNDLE/B33206159.416285564;dc_trk_aid=608684678;dc_trk_cid=231267149;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1"
          target="_blank"
          rel="noopener noreferrer"
          className="discover-link"
        >
          Hemen Keşfet
        </a>
      </div>
    </div>
  );
};

export default Discover;
